import React, { useRef, useState, useLayoutEffect } from 'react';
import { Skeleton } from '@material-ui/lab';
import { Paper, Table, TableBody, TableHead, TableCell,  TableRow } from '@material-ui/core';
import { useTableStyle } from '../../utils/materialStyles';

const ROW_HEIGHT = 34;
const HEADER_HEIGHT = 40;
const BOTTOM_GAP = 24;
const MIN_ROWS = 4;

const STableLoader = ({count, rowsFill}) => {
  const classes = useTableStyle();
  const containerRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState(null);

  useLayoutEffect(() => {
    const updateHeight = () => {
      if (containerRef.current) {
        const top = containerRef.current.getBoundingClientRect().top;
        setContainerHeight(Math.max(window.innerHeight - top - BOTTOM_GAP, HEADER_HEIGHT + ROW_HEIGHT * MIN_ROWS));
      }
    };
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  const responsiveRows = containerHeight ? Math.floor((containerHeight - HEADER_HEIGHT) / ROW_HEIGHT) : MIN_ROWS;
  const rows = Math.max(rowsFill || 0, MIN_ROWS, responsiveRows);
  return(
    <Paper ref={containerRef} style={containerHeight ? { height: containerHeight, overflow: 'hidden' } : undefined}>
      <Table
        className={classes.table}
        aria-labelledby="tableTitle"
        stickyHeader={true}
        size='medium'
      >
        <TableHead className="mui-table s-table-loader-head">
          <TableRow>
            {Array(count).fill(0).map((item, index) =>
              <TableCell align="left">
                <Skeleton variant="rect" animation='wave' height={24} />
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
        {Array(rows).fill(0).map((row, index) =>
          <TableRow key={index}>
            {Array(count).fill(0).map((item, index) =>
              <TableCell align="left">
                <Skeleton variant="rect" animation='wave' height={34} />
              </TableCell>
            )}
          </TableRow>
        )}
        </TableBody>
      </Table>
    </Paper>
  )
}
export default STableLoader;
